<div class="fixed lg:sticky top-0 bottom-0 lg:left-full w-full sm:w-96 lg:w-16 lg:h-screen lg:shadow">
    <div
        class="flex flex-col w-full sm:w-96 h-full transition-transform duration-400 ease-drawer bg-card"
        [ngClass]="{'-translate-x-full sm:-translate-x-96 lg:-translate-x-80 shadow': opened, 'translate-x-0': !opened}">

        <!-- Header -->
        <div
            class="quick-chat-header flex flex-0 items-center justify-start cursor-pointer"
            (click)="toggle()">

            <!-- Toggle -->
            <ng-container *ngIf="!opened || (opened && !selectedChat)">
                <div class="flex flex-auto items-center justify-center">
                    <div class="flex flex-0 items-center justify-center w-16">
                        <mat-icon
                            class="icon-size-6"
                            [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
                    </div>
                    <div class="text-lg font-medium text-secondary">Chat</div>
                    <button
                        class="ml-auto mr-4"
                        mat-icon-button>
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                </div>
            </ng-container>

            <!-- Contact info -->

            <ng-container *ngIf="opened && selectedChat">
                <div class="flex flex-auto items-center ml-3">
                    <div class="relative flex flex-0 items-center justify-center w-10 h-10">
                        <ng-container *ngIf="chat">
                            <ng-container *ngIf="chat.contact && chat.contact.avatar">
                                <img
                                    class="w-full h-full rounded-full object-cover"
                                    [src]="chat.contact.avatar"
                                    alt="Contact avatar"/>
                            </ng-container>
                            <ng-container *ngIf="!chat.contact?.avatar">
                                <div class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                    {{ chat.Sender}} <!-- Usa Title o _id come fallback -->
                                </div>
                            </ng-container>
                        </ng-container>
                        
                        
                    </div>
                    <div class="ml-4 text-lg font-medium leading-5 truncate">{{chat.Sender}}</div>
                    <button
                        class="ml-auto mr-4"
                        mat-icon-button>
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                    </button>
                </div>
            </ng-container>
        </div>

        

        <!-- Content -->
        <div class="flex flex-auto border-t overflow-hidden">
            <!-- Chat list -->
            <div
            class="flex-0 w-16 h-full overflow-y-auto overscroll-y-contain sm:overflow-hidden sm:overscroll-auto"
            fuseScrollbar
            [fuseScrollbarOptions]="{wheelPropagation: false}">
            <div class="flex-auto">

                <div class="flex items-center justify-center p-4">
                    <button
                        mat-icon-button
                        (click)="openNewChatModal()">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                    </button>
                </div>

                <ng-container *ngFor="let chat of chats; trackBy: trackByFn">
                    <div
                        class="flex items-center py-3 px-4 cursor-pointer"
                        [ngClass]="{'hover:bg-gray-100 dark:hover:bg-hover': !selectedChat || selectedChat._id !== chat._id,
                                    'bg-primary-50 dark:bg-hover': selectedChat && selectedChat._id === chat._id}"
                        (click)="selectChat(chat._id)">
                        <div class="relative flex flex-0 items-center justify-center w-8 h-8">
                            <ng-container *ngIf="chat.unreadCount > 0">
                                <div
                                    class="absolute bottom-0 right-0 flex-0 w-2 h-2 -ml-0.5 rounded-full ring-2 ring-bg-card dark:ring-gray-900 bg-new-messages-badge dark:bg-new-messages-badge text-on-primary"
                                    [class.ring-primary-50]="selectedChat && selectedChat._id === chat._id"></div>
                            </ng-container>
                            <!-- Display chat title as the chat name -->
                            <div class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                {{ chat.Title?.slice(0, 2) }}
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>
            </div>


            <!-- Conversation -->
            <div class="flex flex-col flex-auto border-l overflow-hidden bg-gray-50 dark:bg-transparent">
                <ng-container *ngIf="messages && messages.length > 0; else selectChatOrStartNew">
                    <div class="flex flex-col-reverse overflow-y-auto overscroll-y-contain">
                        <div class="flex flex-col flex-auto shrink p-6">
                            <div class="flex items-center justify-center w-full h-full rounded-full text-lg uppercase bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200">
                                {{ selectedChat.Title }}
                            </div>
                            <ng-container *ngFor="let message of messages; let i = index; let first = first; let last = last; trackBy: trackByFn">
                                <!-- Start of the day -->
                                <ng-container *ngIf="first || (messages[i - 1].SendDate | date:'d') !== (message.SendDate | date:'d')">
                                    <div class="flex items-center justify-center my-3 -mx-6">
                                        <div class="flex-auto border-b"></div>
                                        <div class="flex-0 mx-4 text-sm font-medium leading-5 text-secondary">
                                            {{message.SendDate | date: 'longDate'}}
                                        </div>
                                        <div class="flex-auto border-b"></div>
                                    </div>
                                </ng-container>
            
                                <div class="flex flex-col" [ngClass]="{'items-end': message.Sender.value === currentUserId, 'items-start': message.Sender.value !== currentUserId}">
                                    <div class="my-0.5 text-sm font-medium text-secondary">
                                        {{ message.Sender.text }}
                                    </div>
                                    <!-- Bubble -->
                                    <div class="relative max-w-3/4 px-3 py-2 rounded-lg"
                                        [ngClass]="{
                                            'bg-my-message items-end': message.Sender.value === currentUserId,
                                            'bg-gray-500 text-gray-50 items-start': message.Sender.value !== currentUserId
                                        }">
                                        <div class="min-w-4 leading-5">
                                            {{ message.Content }} <!-- Mostra il contenuto del messaggio -->
                                        </div>
                                    </div>
                                
                                    <!-- Mostra l'orario del messaggio -->
                                    <div class="my-0.5 text-sm font-medium text-secondary" style="padding-bottom: 5px;">
                                        {{ message.SendDate | date:'HH:mm' }}
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>        
                </ng-container>
            
                <!-- Placeholder when there are no messages -->
                <ng-template #selectChatOrStartNew>
                    <div class="flex flex-auto items-center justify-center p-4">
                        <div *ngIf="!selectedChat" class="text-xl font-medium tracking-tight text-secondary">Apri una chat per iniziare</div>
                        <div *ngIf="selectedChat" class="text-xl font-medium tracking-tight text-secondary">Inizia la conversazione</div>
                    </div>
                </ng-template> 
                <div *ngIf="selectedChat" class="flex items-end p-4 border-t bg-gray-50 dark:bg-transparent">
                    <mat-form-field
                        class="fuse-mat-dense fuse-mat-rounded fuse-mat-bold w-full"
                        [subscriptSizing]="'dynamic'">
                        <textarea
                            matInput
                            cdkTextareaAutosize
                            #messageInput
                            [(ngModel)]="newMessage"
                            >
                            </textarea>
                    </mat-form-field>
                    <div class="flex items-center h-11 my-px ml-4">
                        <button
                            mat-icon-button
                            (click)="sendMessage(newMessage, selectedChat)">
                            <mat-icon [svgIcon]="'heroicons_outline:paper-airplane'"></mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
